/**
 * Fabpad Offers — Multi-buy packs, Build Your Own Bag, Prebuilt combos
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fabpad-offers]');
  if (!root) return;

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var COPY = {
    multibuy: {
      heading: 'Your best deal is one click away.',
      subheading: 'Pick a quantity. Prices update live for every product.'
    },
    byob: {
      heading: 'Build your own bag.',
      subheading: 'Mix products in one bag. Choose size & colour as you add.'
    },
    'prebuilt-combo': {
      heading: 'Ready-made period kits, ready to go.',
      subheading: 'Complete kits at 25%+ off vs building the same basket. Choose a size and add to bag.'
    }
  };

  var state = {
    mode: 'prebuilt-combo',
    qty: 2,
    savePct: 10,
    packSize: 3,
    bagSavePct: 15,
    slots: [null, null, null],
    category: 'all',
    sort: 'price-asc',
    activeSlot: null,
    pendingProduct: null,
    pendingIntent: 'byob',
    selectedOptions: {}
  };

  var byobBuilder = root.querySelector('[data-byob-builder]');
  var slotsEl = root.querySelector('[data-byob-slots]');
  var progressEl = root.querySelector('[data-byob-progress]');
  var totalEl = root.querySelector('[data-byob-total]');
  var compareEl = root.querySelector('[data-byob-compare]');
  var checkoutBtn = root.querySelector('[data-byob-checkout]');
  var categorySelect = root.querySelector('[data-filter-category]');
  var qtySelect = root.querySelector('[data-filter-qty]');
  var sortSelect = root.querySelector('[data-offers-sort]');
  var countEl = root.querySelector('[data-offers-count]');
  var emptyEl = root.querySelector('[data-offers-empty]');
  var grid = root.querySelector('[data-offers-grid]');
  var banner = root.querySelector('[data-offers-banner]');
  var bannerText = root.querySelector('[data-offers-banner-text]');
  var headingEl = root.querySelector('[data-offers-heading]');
  var subheadingEl = root.querySelector('[data-offers-subheading]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-offers-card]'));
  var modal = root.querySelector('[data-byob-modal]');
  var modalTitle = root.querySelector('[data-byob-modal-title]');
  var modalMedia = root.querySelector('[data-byob-modal-media]');
  var modalOptions = root.querySelector('[data-byob-modal-options]');
  var modalPrice = root.querySelector('[data-byob-modal-price]');
  var modalCompare = root.querySelector('[data-byob-modal-compare]');
  var modalSave = root.querySelector('[data-byob-modal-save]');
  var modalAdd = root.querySelector('[data-byob-modal-add]');
  var moneyFormat =
    root.getAttribute('data-money-format') ||
    (window.Shopify && window.Shopify.money_format) ||
    '₹{{amount}}';

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, moneyFormat);
      } catch (e) {
        /* fall through */
      }
    }
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) {
      return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
    }
    return '₹' + amount;
  }

  function saveLabel(price, compareAt) {
    if (!compareAt || compareAt <= price) return '';
    return 'SAVE ' + Math.round(((compareAt - price) / compareAt) * 100) + '%';
  }

  function sizeDisplayName(value) {
    var key = String(value || '').trim();
    var map = {
      S: 'Small',
      Small: 'Small',
      M: 'Medium',
      Medium: 'Medium',
      L: 'Large',
      Large: 'Large',
      XL: 'X-Large',
      'X-Large': 'X-Large',
      'X Large': 'X-Large',
      'Extra Large': 'X-Large',
      XXL: 'XXL',
      '2XL': 'XXL',
      '2X': 'XXL',
      XXXL: 'XXXL',
      '3XL': 'XXXL',
      '3X': 'XXXL',
      '4XL': '4XL',
      '4X': '4XL'
    };
    return map[key] || key;
  }

  function openCartAfterAdd(payload) {
    if (window.FabpadCart && typeof window.FabpadCart.afterAdd === 'function') {
      return window.FabpadCart.afterAdd(payload);
    }
    var refresh =
      window.FabpadCart && typeof window.FabpadCart.refresh === 'function'
        ? window.FabpadCart.refresh()
        : Promise.resolve();
    return refresh;
  }

  function parseJson(el) {
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function pluralize(qty, label) {
    if (qty === 1) return '1 ' + label;
    if (label === 'pair') return qty + ' pairs';
    return qty + ' ' + label + 's';
  }

  function tierPrice(unitPrice, qty, savePct) {
    return Math.round((unitPrice * qty * (100 - savePct)) / 100);
  }

  function filledCount() {
    return state.slots.filter(Boolean).length;
  }

  function firstEmptySlot() {
    for (var i = 0; i < state.slots.length; i += 1) {
      if (!state.slots[i]) return i;
    }
    return -1;
  }

  function resizeSlots(size) {
    var next = [];
    for (var i = 0; i < size; i += 1) {
      next[i] = state.slots[i] || null;
    }
    state.slots = next;
    state.packSize = size;
  }

  function setMode(mode) {
    state.mode = mode;
    root.setAttribute('data-offers-mode', mode);

    root.querySelectorAll('[data-offers-mode-btn]').forEach(function (btn) {
      var active = btn.getAttribute('data-offers-mode-btn') === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (byobBuilder) byobBuilder.hidden = mode !== 'byob';

    var qtyGroup = qtySelect && qtySelect.closest('.fabpad-offers__filter-group');
    if (qtyGroup) qtyGroup.hidden = mode !== 'multibuy';

    var filtersEl = root.querySelector('[data-offers-filters]');
    if (filtersEl) filtersEl.hidden = mode === 'prebuilt-combo';

    if (banner && mode !== 'multibuy') banner.hidden = true;

    var copy = COPY[mode] || COPY.multibuy;
    if (headingEl) headingEl.textContent = copy.heading;
    if (subheadingEl) subheadingEl.textContent = copy.subheading;

    if (sortSelect) {
      var bestOpt = sortSelect.querySelector('[data-multibuy-sort]');
      if (bestOpt) {
        bestOpt.hidden = mode !== 'multibuy';
        bestOpt.disabled = mode !== 'multibuy';
      }
      if (mode === 'prebuilt-combo') {
        if (state.sort === 'best-savings') state.sort = 'price-asc';
        sortSelect.value = state.sort;
      } else if (mode === 'byob') {
        if (state.sort === 'best-savings') state.sort = 'title';
        sortSelect.value = state.sort;
      } else if (mode === 'multibuy') {
        state.sort = 'best-savings';
        sortSelect.value = 'best-savings';
      }
    }

    cards.forEach(function (card) {
      var btn = card.querySelector('[data-offers-add]');
      if (!btn) return;
      if (card.getAttribute('data-offers-kind') === 'prebuilt-combo') {
        btn.textContent = 'Add kit';
      } else {
        btn.textContent = mode === 'byob' ? 'Add to bag' : 'Add pack';
      }
    });

    root.classList.toggle('is-byob-mode', mode === 'byob');
    root.classList.toggle('is-multibuy-mode', mode === 'multibuy');
    root.classList.toggle('is-prebuilt-mode', mode === 'prebuilt-combo');

    if (mode === 'prebuilt-combo') {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#prebuilt-combo');
      }
    } else if (window.location.hash.indexOf('prebuilt') === 1) {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    if (mode === 'byob') {
      renderSlots();
    } else if (mode === 'multibuy') {
      updateBanner();
    }
    renderGrid();
  }

  function updateBanner() {
    if (!banner || !bannerText || state.mode !== 'multibuy') return;
    if (state.qty <= 1 || state.savePct <= 0) {
      banner.hidden = true;
      return;
    }
    banner.hidden = false;
    bannerText.innerHTML =
      'Showing <strong>Buy ' +
      state.qty +
      ' pricing</strong> for all products. ' +
      state.savePct +
      '% off applied automatically.';
  }

  function updateMultibuyCards() {
    cards.forEach(function (card) {
      var unitPrice = Number(card.getAttribute('data-unit-price')) || 0;
      var unitCompare = Number(card.getAttribute('data-unit-compare')) || unitPrice;
      var unitLabel = card.getAttribute('data-unit-label') || 'pack';
      var qty = state.qty;
      var savePct = state.savePct;
      var price = tierPrice(unitPrice, qty, savePct);
      var compare = unitCompare * qty;

      var priceEl = card.querySelector('[data-offers-price]');
      var compareElCard = card.querySelector('[data-offers-compare]');
      var saveEl = card.querySelector('[data-offers-save]');
      var qtyEl = card.querySelector('[data-offers-qty-label]');
      var badge = card.querySelector('[data-offers-badge]');
      var isKit = card.getAttribute('data-offers-kind') === 'prebuilt-combo';

      if (state.mode === 'multibuy' && !isKit) {
        if (priceEl) priceEl.textContent = formatMoney(price);
        if (qtyEl) {
          qtyEl.hidden = false;
          qtyEl.textContent = pluralize(qty, unitLabel);
        }
        if (compareElCard) {
          if (savePct > 0 && compare > price) {
            compareElCard.textContent = formatMoney(compare);
            compareElCard.hidden = false;
          } else {
            compareElCard.hidden = true;
          }
        }
        if (saveEl) saveEl.hidden = true;
        if (badge) {
          if (savePct > 0) {
            badge.textContent = savePct + '% off';
            badge.hidden = false;
          } else {
            badge.hidden = true;
          }
        }
        card.setAttribute('data-tier-price', String(price));
        card.setAttribute('data-tier-save', String(Math.max(0, compare - price)));
      } else {
        if (priceEl) priceEl.textContent = formatMoney(unitPrice);
        if (qtyEl) qtyEl.hidden = true;
        if (compareElCard) {
          if (unitCompare > unitPrice) {
            compareElCard.textContent = formatMoney(unitCompare);
            compareElCard.hidden = false;
          } else {
            compareElCard.hidden = true;
          }
        }
        if (saveEl) {
          var unitSave = saveLabel(unitPrice, unitCompare);
          saveEl.textContent = unitSave;
          saveEl.hidden = !unitSave;
        }
        if (badge) badge.hidden = true;
        card.setAttribute('data-tier-price', String(unitPrice));
        card.setAttribute('data-tier-save', '0');
      }
    });
  }

  function bagTotals() {
    var compare = 0;
    state.slots.forEach(function (slot) {
      if (!slot) return;
      compare += Number(slot.price) || 0;
    });
    var total = Math.round((compare * (100 - state.bagSavePct)) / 100);
    if (filledCount() < state.packSize) total = compare;
    return {
      compare: compare,
      total: total,
      discounted: filledCount() >= state.packSize && state.bagSavePct > 0
    };
  }

  function renderSlots() {
    if (!slotsEl) return;
    slotsEl.innerHTML = '';

    state.slots.forEach(function (slot, index) {
      var wrap = document.createElement('div');
      wrap.className = 'fabpad-byob__slot' + (slot ? ' is-filled' : '');
      wrap.setAttribute('data-slot-index', String(index));

      if (slot) {
        wrap.innerHTML =
          '<button type="button" class="fabpad-byob__slot-card" data-slot-clear="' +
          index +
          '" aria-label="Remove slot ' +
          (index + 1) +
          '">' +
          (slot.image
            ? '<img class="fabpad-byob__slot-image" src="' + slot.image + '" alt="">'
            : '<span class="fabpad-byob__slot-plus" aria-hidden="true">+</span>') +
          '<span class="fabpad-byob__slot-remove" aria-hidden="true">×</span>' +
          '</button>' +
          '<span class="fabpad-byob__slot-label">#' +
          (index + 1) +
          '</span>';
      } else {
        wrap.innerHTML =
          '<button type="button" class="fabpad-byob__slot-card" data-slot-focus="' +
          index +
          '" aria-label="Add product to slot ' +
          (index + 1) +
          '">' +
          '<span class="fabpad-byob__slot-plus" aria-hidden="true">+</span>' +
          '</button>' +
          '<span class="fabpad-byob__slot-label">#' +
          (index + 1) +
          '</span>';
      }

      slotsEl.appendChild(wrap);
    });

    updateSummary();
  }

  function updateSummary() {
    var filled = filledCount();
    var totals = bagTotals();

    if (progressEl) {
      if (filled >= state.packSize) {
        progressEl.textContent = 'Pack complete · ' + state.bagSavePct + '% off applied';
      } else {
        progressEl.textContent =
          filled +
          ' of ' +
          state.packSize +
          ' added · add ' +
          (state.packSize - filled) +
          ' more for ' +
          state.bagSavePct +
          '% off';
      }
    }

    if (totalEl) totalEl.textContent = formatMoney(totals.total);

    if (compareEl) {
      if (totals.discounted && totals.compare > totals.total) {
        compareEl.textContent = formatMoney(totals.compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (checkoutBtn) {
      checkoutBtn.disabled = filled < state.packSize;
      checkoutBtn.textContent =
        filled < state.packSize
          ? 'Add ' + (state.packSize - filled) + ' more'
          : 'Add bag to cart · ' + formatMoney(totals.total);
    }
  }

  function optionValues(option) {
    if (!option || !option.values) return [];
    return option.values;
  }

  function looksLikeDisposableSize(option) {
    var n = String((option && option.name) || '').toLowerCase();
    if (n.indexOf('disposable') !== -1 || n.indexOf('use-throw') !== -1 || n.indexOf('use and throw') !== -1) {
      return true;
    }
    return optionValues(option).some(function (value) {
      return String(value).indexOf('/') !== -1;
    });
  }

  function isKitSizeOption(option) {
    var n = String((option && option.name) || '').toLowerCase();
    if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) return false;
    if (n.indexOf('size') !== -1 || n.indexOf('panty') !== -1 || n.indexOf('underwear') !== -1 || n.indexOf('waist') !== -1) {
      return true;
    }
    return looksLikeDisposableSize(option);
  }

  function kitOptionCopy(option, productData) {
    if (looksLikeDisposableSize(option)) {
      return {
        label: 'Disposable panty size',
        hint: 'This size is for the disposable period panties in this kit.'
      };
    }
    return {
      label: (productData && productData.sizeFor) || 'Reusable panty size',
      hint: (productData && productData.sizeHint) || 'This size is for the reusable underwear in this kit — Mid waist, Black.'
    };
  }

  function optionKind(option, productData, intent) {
    var name = option && typeof option === 'object' ? option.name : option;
    var n = String(name || '').toLowerCase();
    if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) return 'Colour';
    if (n.indexOf('size') !== -1 || (intent === 'prebuilt' && looksLikeDisposableSize(option))) {
      if (intent === 'prebuilt' && productData) return kitOptionCopy(option, productData).label;
      return 'Size';
    }
    if (n.indexOf('absorb') !== -1 || n.indexOf('flow') !== -1) return 'Absorbency';
    if (n.indexOf('pack') !== -1) return 'Pack';
    return name || 'Option';
  }

  function findVariant(variants, selected) {
    return variants.find(function (v) {
      return (
        (!selected.option1 || v.option1 === selected.option1) &&
        (!selected.option2 || v.option2 === selected.option2) &&
        (!selected.option3 || v.option3 === selected.option3)
      );
    });
  }

  function currentModalVariant() {
    if (!state.pendingProduct) return null;
    return findVariant(state.pendingProduct.variants, state.selectedOptions);
  }

  function updateModalPrice() {
    var variant = currentModalVariant();
    if (!modalPrice) return;
    if (!variant) {
      var fallback = state.pendingProduct && state.pendingProduct.variants && state.pendingProduct.variants[0];
      if (state.pendingIntent === 'prebuilt' && fallback) {
        modalPrice.textContent = formatMoney(fallback.price);
      } else {
        modalPrice.textContent = 'Select options';
      }
      if (modalAdd) {
        modalAdd.disabled = true;
        modalAdd.textContent = state.pendingIntent === 'prebuilt' ? 'Select size' : 'Add to bag';
      }
      return;
    }

    if (state.pendingIntent === 'multibuy') {
      var price = tierPrice(variant.price, state.qty, state.savePct);
      modalPrice.textContent = formatMoney(price);
      if (modalCompare) {
        var packCompare = (variant.compare_at_price || variant.price) * state.qty;
        if (state.savePct > 0 && packCompare > price) {
          modalCompare.textContent = formatMoney(packCompare);
          modalCompare.hidden = false;
        } else {
          modalCompare.hidden = true;
        }
      }
      if (modalSave) {
        modalSave.textContent = state.savePct > 0 ? 'SAVE ' + state.savePct + '%' : '';
        modalSave.hidden = state.savePct <= 0;
      }
    } else {
      modalPrice.textContent = formatMoney(variant.price);
      if (modalCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          modalCompare.textContent = formatMoney(variant.compare_at_price);
          modalCompare.hidden = false;
        } else {
          modalCompare.hidden = true;
        }
      }
      if (modalSave) {
        var label = saveLabel(variant.price, variant.compare_at_price);
        modalSave.textContent = label;
        modalSave.hidden = !label;
      }
    }

    if (modalAdd) {
      modalAdd.disabled = !variant.available;
      if (state.pendingIntent === 'prebuilt') {
        modalAdd.textContent = variant.available ? 'Add kit' : 'Back soon';
      }
    }
    if (modalMedia && variant.image) {
      modalMedia.innerHTML = '<img src="' + variant.image + '" alt="">';
    }
  }

  function openModal(productData, intent, preferSlot) {
    state.pendingProduct = productData;
    state.pendingIntent = intent;
    state.activeSlot = typeof preferSlot === 'number' ? preferSlot : firstEmptySlot();
    state.selectedOptions = {};

    var firstAvailable =
      productData.variants.find(function (v) {
        return v.available;
      }) || productData.variants[0];

    if (intent !== 'prebuilt' && firstAvailable) {
      if (firstAvailable.option1) state.selectedOptions.option1 = firstAvailable.option1;
      if (firstAvailable.option2) state.selectedOptions.option2 = firstAvailable.option2;
      if (firstAvailable.option3) state.selectedOptions.option3 = firstAvailable.option3;
    }

    if (modalTitle) modalTitle.textContent = productData.title;
    if (modalMedia) {
      var img = (firstAvailable && firstAvailable.image) || productData.image;
      modalMedia.innerHTML = img ? '<img src="' + img + '" alt="">' : '';
    }

    if (modalOptions) {
      modalOptions.innerHTML = '';
      productData.options.forEach(function (option) {
        var kitCopy = intent === 'prebuilt' && isKitSizeOption(option) ? kitOptionCopy(option, productData) : null;
        var groupLabel = kitCopy ? kitCopy.label : optionKind(option, productData, intent);
        var group = document.createElement('div');
        group.className = 'fabpad-byob-modal__group';
        group.innerHTML =
          '<div class="fabpad-byob-modal__group-head"><span class="fabpad-byob-modal__group-label">' +
          groupLabel +
          '</span></div>';

        if (kitCopy && kitCopy.hint) {
          var hint = document.createElement('p');
          hint.className = 'fabpad-byob-modal__hint';
          hint.textContent = kitCopy.hint;
          group.appendChild(hint);
        }

        var chips = document.createElement('div');
        chips.className = 'fabpad-byob-modal__chips';

        option.values.forEach(function (value) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'fabpad-byob-modal__chip';
          chip.textContent =
            intent === 'prebuilt' && isKitSizeOption(option) && !looksLikeDisposableSize(option)
              ? sizeDisplayName(value)
              : value;
          chip.setAttribute('data-option-value', value);
          var key = 'option' + option.position;
          if (state.selectedOptions[key] === value) chip.classList.add('is-active');
          chip.addEventListener('click', function () {
            state.selectedOptions[key] = value;
            chips.querySelectorAll('.fabpad-byob-modal__chip').forEach(function (c) {
              c.classList.toggle('is-active', c.getAttribute('data-option-value') === value);
            });
            updateModalPrice();
          });
          chips.appendChild(chip);
        });

        group.appendChild(chips);
        modalOptions.appendChild(group);
      });

      if (!productData.options.length) {
        modalOptions.innerHTML = '<p class="fabpad-byob-modal__note">One size / option available.</p>';
      }
    }

    if (modalAdd) {
      modalAdd.textContent =
        intent === 'multibuy' ? 'Add pack' : intent === 'prebuilt' ? 'Add kit' : 'Add to bag';
    }

    updateModalPrice();
    if (modal) {
      modal.hidden = false;
      document.body.classList.add('fabpad-byob-modal-open');
    }
  }

  function closeModal() {
    if (modal) modal.hidden = true;
    document.body.classList.remove('fabpad-byob-modal-open');
    state.pendingProduct = null;
    state.activeSlot = null;
  }

  function readCardProduct(card) {
    return {
      id: card.getAttribute('data-product-id'),
      title: card.getAttribute('data-title') || '',
      image: card.getAttribute('data-product-image') || '',
      url: card.getAttribute('data-product-url') || '',
      sizeFor: card.getAttribute('data-size-for') || '',
      sizeHint: card.getAttribute('data-size-hint') || '',
      options: parseJson(card.querySelector('[data-product-options]')),
      variants: parseJson(card.querySelector('[data-product-variants]'))
    };
  }

  function addVariantToBag(variant, product) {
    if (state.activeSlot == null || state.activeSlot < 0) {
      state.activeSlot = firstEmptySlot();
    }
    if (state.activeSlot < 0 || state.activeSlot >= state.packSize) {
      closeModal();
      return;
    }

    state.slots[state.activeSlot] = {
      variantId: variant.id,
      productId: product.id,
      title: product.title,
      price: variant.price,
      compare: variant.compare_at_price || variant.price,
      image: variant.image || product.image
    };

    closeModal();
    renderSlots();
  }

  function addPrebuiltToCart(variant) {
    if (!modalAdd) return;
    modalAdd.disabled = true;
    var original = modalAdd.textContent;
    modalAdd.textContent = 'Adding…';

    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variant.id), quantity: 1 }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function (data) {
        return openCartAfterAdd(data);
      })
      .then(function () {
        closeModal();
        modalAdd.textContent = original;
        modalAdd.disabled = false;
      })
      .catch(function () {
        modalAdd.textContent = 'Try again';
        modalAdd.disabled = false;
        setTimeout(function () {
          modalAdd.textContent = original;
        }, 1200);
      });
  }

  function addMultibuyToCart(variant) {
    if (!modalAdd) return;
    modalAdd.disabled = true;
    var original = modalAdd.textContent;
    modalAdd.textContent = 'Adding…';

    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variant.id), quantity: state.qty }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function (data) {
        return openCartAfterAdd(data);
      })
      .then(function () {
        closeModal();
        modalAdd.textContent = original;
        modalAdd.disabled = false;
      })
      .catch(function () {
        modalAdd.textContent = 'Try again';
        modalAdd.disabled = false;
        setTimeout(function () {
          modalAdd.textContent = original;
        }, 1200);
      });
  }

  function matchesCategory(card) {
    if (state.category === 'all') return true;
    var cats = (card.getAttribute('data-categories') || '').split(',');
    return cats.indexOf(state.category) !== -1;
  }

  function sortCards(list) {
    return list.slice().sort(function (a, b) {
      var pa = Number(a.getAttribute('data-tier-price')) || 0;
      var pb = Number(b.getAttribute('data-tier-price')) || 0;
      var sa = Number(a.getAttribute('data-tier-save')) || 0;
      var sb = Number(b.getAttribute('data-tier-save')) || 0;
      var ta = (a.getAttribute('data-title') || '').toLowerCase();
      var tb = (b.getAttribute('data-title') || '').toLowerCase();

      if (state.sort === 'price-asc') return pa - pb;
      if (state.sort === 'price-desc') return pb - pa;
      if (state.sort === 'best-savings') return sb - sa || pa - pb;
      return ta.localeCompare(tb);
    });
  }

  function updateCategoryCounts() {
    if (!categorySelect) return;
    var totals = {
      all: 0,
      'period-underwear': 0,
      'period-care': 0,
      biodegradable: 0,
      wellness: 0,
      mens: 0
    };

    cards.forEach(function (card) {
      if (card.getAttribute('data-offers-kind') === 'prebuilt-combo') return;
      totals.all += 1;
      var cats = (card.getAttribute('data-categories') || '').split(',');
      Object.keys(totals).forEach(function (key) {
        if (key === 'all') return;
        if (cats.indexOf(key) !== -1) totals[key] += 1;
      });
    });

    Array.prototype.forEach.call(categorySelect.options, function (option) {
      var key = option.value;
      var label = option.getAttribute('data-label') || option.value;
      var count = totals[key];
      option.textContent = typeof count === 'number' ? label + ' (' + count + ')' : label;
    });
  }

  function renderGrid() {
    updateCategoryCounts();
    updateMultibuyCards();

    var visible = cards.filter(function (card) {
      var isKit = card.getAttribute('data-offers-kind') === 'prebuilt-combo';
      if (state.mode === 'prebuilt-combo') return isKit;
      return !isKit && matchesCategory(card);
    });
    var ordered = sortCards(visible);

    cards.forEach(function (card) {
      card.hidden = true;
    });

    ordered.forEach(function (card) {
      card.hidden = false;
      if (grid) grid.appendChild(card);
    });

    if (countEl) countEl.textContent = String(ordered.length);
    if (emptyEl) {
      emptyEl.hidden = ordered.length > 0;
      emptyEl.textContent =
        state.mode === 'prebuilt-combo'
          ? 'Ready-made kits will show here once they are published.'
          : 'No products match these filters.';
    }
  }

  root.querySelectorAll('[data-offers-mode-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setMode(btn.getAttribute('data-offers-mode-btn') || 'multibuy');
    });
  });

  root.querySelectorAll('[data-pack-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var size = Number(btn.getAttribute('data-pack-size')) || 3;
      var pct = Number(btn.getAttribute('data-save-pct')) || 0;
      state.bagSavePct = pct;
      resizeSlots(size);

      root.querySelectorAll('[data-pack-size]').forEach(function (el) {
        var active = el === btn;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      renderSlots();
    });
  });

  if (slotsEl) {
    slotsEl.addEventListener('click', function (event) {
      var clearBtn = event.target.closest('[data-slot-clear]');
      if (clearBtn) {
        state.slots[Number(clearBtn.getAttribute('data-slot-clear'))] = null;
        renderSlots();
        return;
      }

      var focusBtn = event.target.closest('[data-slot-focus]');
      if (!focusBtn) return;
      state.activeSlot = Number(focusBtn.getAttribute('data-slot-focus'));
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  root.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-offers-add]');
    if (addBtn) {
      var card = addBtn.closest('[data-offers-card]');
      if (!card) return;

      if (state.mode === 'byob') {
        if (firstEmptySlot() === -1) return;
        openModal(readCardProduct(card), 'byob', firstEmptySlot());
      } else if (card.hasAttribute('data-kit-card')) {
        return;
      } else if (state.mode === 'prebuilt-combo' || card.getAttribute('data-offers-kind') === 'prebuilt-combo') {
        openModal(readCardProduct(card), 'prebuilt');
      } else {
        openModal(readCardProduct(card), 'multibuy');
      }
      return;
    }

    if (event.target.closest('[data-byob-modal-close]')) closeModal();
  });

  if (modalAdd) {
    modalAdd.addEventListener('click', function () {
      var variant = currentModalVariant();
      if (!variant || !variant.available || !state.pendingProduct) return;

      if (state.pendingIntent === 'multibuy') {
        addMultibuyToCart(variant);
      } else if (state.pendingIntent === 'prebuilt') {
        addPrebuiltToCart(variant);
      } else {
        addVariantToBag(variant, state.pendingProduct);
      }
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (filledCount() < state.packSize) return;

      var items = state.slots.filter(Boolean).map(function (slot) {
        return { id: Number(slot.variantId), quantity: 1 };
      });

      checkoutBtn.disabled = true;
      var original = checkoutBtn.textContent;
      checkoutBtn.textContent = 'Adding…';

      fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function (data) {
          return openCartAfterAdd(data);
        })
        .then(function () {
          state.slots = state.slots.map(function () {
            return null;
          });
          renderSlots();
          checkoutBtn.textContent = original;
          updateSummary();
        })
        .catch(function () {
          checkoutBtn.textContent = 'Try again';
          checkoutBtn.disabled = false;
          setTimeout(function () {
            checkoutBtn.textContent = original;
            updateSummary();
          }, 1200);
        });
    });
  }

  if (categorySelect) {
    categorySelect.addEventListener('change', function () {
      state.category = categorySelect.value || 'all';
      renderGrid();
    });
  }

  if (qtySelect) {
    qtySelect.addEventListener('change', function () {
      var selected = qtySelect.options[qtySelect.selectedIndex];
      state.qty = Number(qtySelect.value) || 1;
      state.savePct = Number(selected && selected.getAttribute('data-save-pct')) || 0;
      updateMultibuyCards();
      updateBanner();
      renderGrid();
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      renderGrid();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  var hash = (window.location.hash || '').replace('#', '');
  var initialMode = 'prebuilt-combo';
  if (hash === 'byob') initialMode = 'byob';
  if (hash === 'multibuy' || hash === 'multi-buy') initialMode = 'multibuy';
  setMode(initialMode);
})();
